

function BoxCall({ image, title, text }) {
    return (
        <div className="flex justify-end items-center mb-7
        xl:w-full
     ">
            <img src={image} className="w-14" />
            <div className="w-full flex flex-col mr-4">
                <p className="text-slate-400">{title}</p>
                <p className="text-slate-800 text-sm w-11/12 text-right">{text}</p>
            </div>
        </div>
    )
}
export default BoxCall;